<template>
  <div :id="mapId" width="100%" height="100%" style="border: 0" />
</template>
<script>
import gmapsInit from "./gmaps";

export default {
  data() {
    return {
      randomNumber: 0,
      myMap: null,
      googleApiKey: "AIzaSyB7WwqK_V5Mklna0-slK5TYlasZfuNirrY",
      zoom: 18,
      distance: 0,
      directionsDisplay: null,
      directionsService: null
    };
  },
  props: ["value", "markerA", "markerB"],
  computed: {
    mapId: function() {
      return "map" + this.randomNumber;
    }
  },
  methods: {
    async initMap() {
      try {
        const google = await gmapsInit();
        const geocoder = new google.maps.Geocoder();
        const map = new google.maps.Map(this.$el, {
          center: {
            lat: Number(this.value.from.lat),
            lng: Number(this.value.from.lng)
          },
          zoom: this.zoom
        });

        this.directionsDisplay = new google.maps.DirectionsRenderer();
        this.directionsService = new google.maps.DirectionsService();
        this.directionsDisplay.setMap(map);

        this.calculateAndDisplayRoute(
          this.directionsService,
          this.directionsDisplay,
          this.value.from.lat,
          this.value.from.lng,
          this.value.to.lat,
          this.value.to.lng
        );
      } catch (error) {
        console.error(error);
      }
    },
    calculateAndDisplayRoute(
      directionsService,
      directionsDisplay,
      originLat,
      originLng,
      destLat,
      destLng
    ) {
      var selectedMode = "DRIVING"; // 'WALKING', 'DRIVING', 'BICYCLING', 'TRANSIT'
      var that = this;
      directionsService.route(
        {
          origin: { lat: Number(originLat), lng: Number(originLng) },
          destination: { lat: Number(destLat), lng: Number(destLng) }, // Muranos Glass Museum
          travelMode: google.maps.TravelMode[selectedMode]
        },
        function(response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
            that.distance =
              Number(response.routes[0].legs[0].distance.value) / 1000;

            that.$emit("input", {
              from: {
                lat: Number(that.value.from.lat),
                lng: Number(that.value.from.lng)
              },
              to: {
                lat: Number(that.value.to.lat),
                lng: Number(that.value.to.lng)
              },
              distance: that.distance
            });
          } else {
            window.alert("Directions request failed due to " + status);
          }
        }
      );
    }
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        if (
          val.from.lat === oldVal.from.lat &&
          val.from.lng === oldVal.from.lng &&
          val.to.lat === oldVal.to.lat &&
          val.to.lng === oldVal.to.lng
        ) {
          return;
        }

        this.calculateAndDisplayRoute(
          this.directionsService,
          this.directionsDisplay,
          this.value.from.lat,
          this.value.from.lng,
          this.value.to.lat,
          this.value.to.lng
        );
      },
      deep: true
    }
  },
  created() {
    this.randomNumber = Math.random()
      .toString()
      .substr(2, 8);
  },
  mounted() {
    this.initMap();
  }
};
</script>
<style lang="scss" scoped></style>
